// removed by extract-text-webpack-plugin
module.exports = {"customers":"app-pages-Customers-__Customer___32vIX","container":"app-pages-Customers-__Customer___3bYRr","container-full-nosub":"app-pages-Customers-__Customer___135I2"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Customers/Customer.css
// module id = 2293
// module chunks = 0